import Storekit_1 from "./Storekit-1.webp";
import Storekit_1_en from "./Storekit-1_en.webp";
import Storekit_2 from "./Storekit-2.webp";
import Storekit_2_en from "./Storekit-2_en.webp";
import Storekit_3 from "./Storekit-3.webp";
import Storekit_3_en from "./Storekit-3_en.webp";
import Storekit_4 from "./Storekit-4.webp";
import Storekit_4_en from "./Storekit-4_en.webp";
import Storekit_5 from "./Storekit-5.webp";
import Storekit_5_en from "./Storekit-5_en.webp";
import s1 from "./1.webp";
import s1_en from "./1_en.webp";
import s2 from "./2.webp";
import s2_en from "./2_en.webp";
import s3 from "./3.webp";
import s3_en from "./3_en.webp";
import s4 from "./4.webp";
import s4_en from "./4_en.webp";
import s5 from "./5.webp";
import s5_en from "./5_en.webp";


export const storekit = [{
        tag: Storekit_1,
        tag_en: Storekit_1_en,
        video: "Storekit_1",
    },
    {
        tag: Storekit_2,
        tag_en: Storekit_2_en,
        video: "Storekit_2",
    },
    {
        tag: Storekit_3,
        tag_en: Storekit_3_en,
        video: "Storekit_3",
    },
    {
        tag: Storekit_4,
        tag_en: Storekit_4_en,
        video: "Storekit_4",
    },
    {
        tag: Storekit_5,
        tag_en: Storekit_5_en,
        video: "Storekit_5",
    },
];

export const storekit2 = [{
        tag: s1,
        tag_en: s1_en,
    },
    {
        tag: s2,
        tag_en: s2_en,
    },
    {
        tag: s3,
        tag_en: s3_en,
    },
    {
        tag: s4,
        tag_en: s4_en,
    },
    {
        tag: s5,
        tag_en: s5_en,
    },
];